import { useFormContext } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useEditContext } from "react-admin";

const CustomDayAndMonthPicker = ({ label }: { label: string }) => {
  const form = useFormContext();
  const { record } = useEditContext();

  return (
    <DatePicker
      onChange={(value: Dayjs | null) =>
        form.setValue("birthday", value?.format("YYYY-MM-DD"), {
          shouldDirty: true
        })
      }
      label={label}
      openTo="month"
      views={["month", "day"]}
      format="MM-DD"
      defaultValue={record?.birthday ? dayjs(record.birthday) : null}
      sx={{ width: "100%", marginBottom: "20px !important" }}
    />
  );
};

export default CustomDayAndMonthPicker;
